export default {
  local: {
    AUTH_SERVICE_URL: 'https://authenticationed1.col.test.expertcity.com',
    AUTH_CALLBACK_URL: 'http://localhost:3000',

    AUTH_DATA_STORAGE_KEY: 'lmi-pp-token',
    AUTH_CODE_VERIFIER_STORAGE_KEY: 'lmi-pp-code-verifier',
    AUTH_STATE_STORAGE_KEY: 'lmi-pp-state',
    AUTH_CLIENT_ID: '377b33ef-b4cb-44b7-80f3-112068c66c8f',
    AUTH_SCOPES: ['pbx.v1.admin', 'identity:'].join(' '),
    AUTH_LDAP: ['platform-admin'].join(','),

    AUTH_LOGOUT_URL: 'https://authenticationed1.lmiinc.test.expertcity.com/oauth/logout',
    AUTH_LOGGED_IN_USER_LINK_URL: 'https://my.jive.com/me/',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 6000,

    AUTH_CLIENT_SECRET: 'Z4erGiJ1wVXVvTp1orDQnmQl', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
  development: {
    AUTH_SERVICE_URL: 'https://authenticationed1.col.test.expertcity.com',
    AUTH_CALLBACK_URL: 'https://my.dev.jive.com/partner',
    AUTH_CLIENT_ID: '377b33ef-b4cb-44b7-80f3-112068c66c8f',
    AUTH_LOGOUT_URL: 'https://authenticationed1.lmiinc.test.expertcity.com/oauth/logout',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 3000,

    AUTH_CLIENT_SECRET: 'Z4erGiJ1wVXVvTp1orDQnmQl', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
  developmentHvoice: {
    AUTH_SERVICE_URL: 'https://authenticationed1.col.test.expertcity.com',
    AUTH_CALLBACK_URL: 'https://my.dev.hvoice.net/partner',
    AUTH_CLIENT_ID: '377b33ef-b4cb-44b7-80f3-112068c66c8f',
    AUTH_LOGOUT_URL: 'https://authenticationed1.lmiinc.test.expertcity.com/oauth/logout',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 3000,
    AUTH_CLIENT_SECRET: 'Z4erGiJ1wVXVvTp1orDQnmQl', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
  staging: {
    AUTH_SERVICE_URL: 'https://authenticationstage.logmeininc.com',
    AUTH_CALLBACK_URL: 'https://my.staging.jive.com/partner',
    AUTH_CLIENT_ID: '7f756a4b-b2d6-404d-a5c4-b20192202473',
    AUTH_LOGOUT_URL: 'https://authenticationstage.logmeininc.com/oauth/logout',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 3000,
    AUTH_CLIENT_SECRET: 'm2nzCNzFjCXAnVFGy8B3dxJB', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
  production: {
    AUTH_SERVICE_URL: 'https://authentication.logmeininc.com',
    AUTH_CALLBACK_URL: 'https://my.jive.com/partner',
    AUTH_CLIENT_ID: '24b9b5f1-265c-403b-a3eb-0d4f707a5694',
    AUTH_LOGOUT_URL: 'https://authentication.logmeininc.com/oauth/logout',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 3000,
    AUTH_CLIENT_SECRET: 'zkVz3PoifUhmF4C1gx6LU1GA', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
  hvoice: {
    AUTH_SERVICE_URL: 'https://authentication.logmeininc.com',
    AUTH_CALLBACK_URL: 'https://my.hvoice.net/partner',
    AUTH_CLIENT_ID: 'c371c455-4300-4ccf-a360-330a36f01bba',
    AUTH_LOGOUT_URL: 'https://authentication.logmeininc.com/oauth/logout',
    AUTH_TOCKEN_VALIDITY_TIMEOUT: 3000,
    AUTH_CLIENT_SECRET: 'x7mPuFu0OJGk2jwWxpMgLwzm', // This is not a real secret, see https://logmein.slack.com/archives/GSD4NDTKR/p1762282600601059?thread_ts=1762279559.379339&cid=GSD4NDTKR
  },
}
